/*
|--------------------------------------------------------------------------
| Package entrypoint
|--------------------------------------------------------------------------
|
| Export values from the package entrypoint as you see fit.
|
*/

export { configure } from './configure.js'
export { stubsRoot } from './stubs/main.js'
export { defineConfig } from './src/define_config.js'

// Types
export type {
  TranslateParams,
  TranslationResult,
  BatchTranslateParams,
  BatchTranslationResult,
  DetectLanguageParams,
  DetectionResult,
  SupportedLanguagesResult,
  LanguageCode,
  GoogleTranslateFreeConfig,
  GoogleTranslatePaidConfig,
  BaseTranslationProvider,
  TranslationConfig,
  TranslationService,
  TranslationProviders,
  InferProviders,
} from './src/types.js'
